<script lang="ts">
    import { onDestroy } from "svelte";
    import { MesurmentStore } from "../../script/probeStore";
    import type { MesurmentFull } from "../../script/types";

    import FTable from "./FTable.svelte";
    import GroupFa from "./actions/GroupFA.svelte";
    import ExpFA from "./actions/ExpFA.svelte";

    import { HeadderConfig, parseToTable } from "./mesFTConfig";
    import {
        reloadGlobalData,
        reloadOrders,
    } from "../../script/din/dataBroker";

    const DEF_FILTER_CONFIG_EXPORT = [
        {
            type: "filter_val",
            trg: {
                atr: 4,
                operaion: "more",
                val: 1,
            },
        },
        {
            type: "filter_val",
            trg: {
                atr: 4,
                operaion: "less",
                val: 5,
            },
        },
    ];

    let defaultFilter = []; // DEF_FILTER_CONFIG_EXPORT

    let headder = HeadderConfig;
    let data = {
        data: [],
    };
    let allMesurment: MesurmentFull[] = [];
    let usedMesurment: MesurmentFull[] = [];
    let selectedMesurment: MesurmentFull[] = [];
    let resetChecks: () => void;
    let selectedMask: boolean[] = [];
    // let selectedCount: number = 0;
    $: data = parseToTable(usedMesurment);
    $: selectedMesurment = usedMesurment.filter((_, i) => selectedMask[i]);
    const mesurmentStoreSub = MesurmentStore.subscribeList((mesList) => {
        usedMesurment = mesList;
        allMesurment = mesList;
    });

    function refreshList() {
        return reloadOrders()
            .then((_) => true)
            .catch((_) => false);
    }

    function cleanUp() {
        mesurmentStoreSub();
    }
    onDestroy(cleanUp);
</script>

<FTable
    {headder}
    {data}
    bind:selectedMask
    bind:resetChecks
    {defaultFilter}
    {refreshList}
>
    <!-- bind:selectedCount -->
    <GroupFa
        bind:allMesurment
        bind:usedMesurment
        bind:selectedMesurment
        {resetChecks}
    />
    <ExpFA bind:selectedMesurment {resetChecks} />
</FTable>

<style>
</style>
